import React from 'react';
import { Card, Descriptions, Space, Typography } from '../../../components';
import { makeNiceName } from '../../../lib/helpers';

const { Text } = Typography;

export const CloudProperties = React.memo(({ applianceProperties }) => {
    return (
        <Card title="Cloud Properties" size="small">
            <Descriptions column={1} size="small">
                {Object.entries(applianceProperties).map(([key, value]) => {
                    if (Array.isArray(value)) {
                        return key === 'disks_types' ? (
                            <Descriptions.Item label={makeNiceName(key, true)}>
                                <Text>{value[0]}</Text>
                            </Descriptions.Item>
                        ) : (
                            <Descriptions.Item label={makeNiceName(key, true)}>
                                <Space orientation="vertical" size={0}>
                                    {Object.entries(value[0]).map(([subKey, subValue]) => (
                                        <Text>
                                            {subKey}: {subValue}{' '}
                                        </Text>
                                    ))}
                                </Space>
                            </Descriptions.Item>
                        );
                    } else if (key !== 'tags') {
                        return (
                            <Descriptions.Item label={makeNiceName(key, true)}>
                                <Text>{value?.toString()}</Text>
                            </Descriptions.Item>
                        );
                    }
                })}
            </Descriptions>
        </Card>
    );
});
